import { Action } from 'redux';
import {  
  IExchangeConfig,
} from '../../services';

export interface IExchangeConfigState {
  loading?: boolean;
  exchangeConfigs?: IExchangeConfig[]; 
  exchangeConfig?: IExchangeConfig;
  exceptionMessage?: string;
  message?: string;
  isPostExchangeConfigSuccess?: boolean;
}

export enum ExchangeConfigActionEnum {
  FetchExchangeConfig = '@@ExchangeConfig/FETCH_ExchangeConfig',
  FetchExchangeConfigSuccess = '@@ExchangeConfig/FETCH_ExchangeConfig_SUCCESS',
  FetchExchangeConfigFailed = '@@ExchangeConfig/FETCH_ExchangeConfig_FAILED',  
  PostExchangeConfig = '@@ExchangeConfig/POST_ExchangeConfig',
  PostExchangeConfigSuccess = '@@ExchangeConfig/POST_ExchangeConfig_SUCCESS',
  PostExchangeConfigFailed = '@@ExchangeConfig/POST_ExchangeConfig_FAILED'
}

export interface IFetchExchangeConfigAction
    extends Action<typeof ExchangeConfigActionEnum.FetchExchangeConfig> {
    state?: IExchangeConfigState;
}

export interface IFetchExchangeConfigSuccessAction
    extends Action<typeof ExchangeConfigActionEnum.FetchExchangeConfigSuccess> {
    state?: IExchangeConfigState;
}

export interface IFetchExchangeConfigFailedAction
    extends Action<typeof ExchangeConfigActionEnum.FetchExchangeConfigFailed> {
    state?: IExchangeConfigState;
}

export interface IPostExchangeConfigAction
  extends Action<typeof ExchangeConfigActionEnum.PostExchangeConfig> {
  state?: IExchangeConfigState;
}

export interface IPostExchangeConfigSuccessAction
  extends Action<typeof ExchangeConfigActionEnum.PostExchangeConfigSuccess> {
  state?: IExchangeConfigState;
}

export interface IPostExchangeConfigFailedAction
  extends Action<typeof ExchangeConfigActionEnum.PostExchangeConfigFailed> {
  state?: IExchangeConfigState;
}

export type ExchangeConfigActions =
    | IFetchExchangeConfigAction
    | IFetchExchangeConfigSuccessAction
    | IFetchExchangeConfigFailedAction
    | IPostExchangeConfigAction
    | IPostExchangeConfigSuccessAction
    | IPostExchangeConfigFailedAction
